"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determineFontSizes = determineFontSizes;

var _Theme = require("../../Theme");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Determines which font sizes/line heights to use for typography.
 */
function determineFontSizes(fontType, size) {
  if (!Array.isArray(size)) {
    var match = _Theme.themeProps.typeSizes[fontType][size];
    return {
      fontSize: "".concat(match.fontSize),
      lineHeight: "".concat(match.lineHeight)
    };
  }

  return size.map(function (s) {
    return _Theme.themeProps.typeSizes[fontType][s];
  }).reduce(function (accumulator, current) {
    return {
      fontSize: [].concat(_toConsumableArray(accumulator.fontSize), ["".concat(current.fontSize)]),
      lineHeight: [].concat(_toConsumableArray(accumulator.lineHeight), ["".concat(current.lineHeight)])
    };
  }, {
    fontSize: [],
    lineHeight: []
  });
}
//# sourceMappingURL=determineFontSizes.js.map